<mat-card appearance="outlined">
  <mat-table [dataSource]="materials" noDataTableMessage>
    <ng-container matColumnDef="materialNumber">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.transportContent.equipments.materials.materialNumber' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index">
        {{ materials[i].materialNumber | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="materialDescription">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.transportContent.equipments.materials.description' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index">
        {{ materials[i].materialDescription | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="grossWeight">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.transportContent.equipments.materials.grossWeight' | translate }}
        <ng-container *ngIf="weightUnitCode">({{ measurementUnitCodes[weightUnitCode] }})</ng-container>
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index">
        {{ materials[i].grossWeight | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="netWeight">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.transportContent.equipments.materials.netWeight' | translate }}
        <ng-container *ngIf="weightUnitCode">({{ measurementUnitCodes[weightUnitCode] }})</ng-container>
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index">
        {{ materials[i].netWeight | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="volume">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.transportContent.equipments.materials.volume' | translate }}
        <ng-container *ngIf="volumeUnitCode">({{ measurementUnitCodes[volumeUnitCode] }})</ng-container>
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index">
        {{ materials[i].volume | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="quantity">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.transportContent.equipments.materials.quantity' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index">
        {{ materials[i].quantity | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="quantityUnitCode">
      <mat-header-cell *matHeaderCellDef>
        {{ 'waybill.transportContent.equipments.materials.quantityUnit' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index">
        {{ materials[i].quantityUnitCode | nullToNotAvailable }}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="materialColumns" class="tw-flex"></mat-header-row>
    <mat-row *matRowDef="let row; columns: materialColumns" class="tw-flex"></mat-row>
  </mat-table>
</mat-card>
